
// Define region polygons
export const regionPolygons = {
  "Occitanie": [
    { lat: 42.3, lng: 1.0 },
    { lat: 42.3, lng: 4.8 },
    { lat: 45.0, lng: 4.8 },
    { lat: 45.0, lng: 1.0 },
    { lat: 42.3, lng: 1.0 }
  ],
  "Auvergne-Rhône-Alpes": [
    { lat: 44.5, lng: 2.0 },
    { lat: 44.5, lng: 4.8 },
    { lat: 46.5, lng: 4.8 },
    { lat: 46.5, lng: 2.0 },
    { lat: 44.5, lng: 2.0 }
  ],
  "Île-de-France": [
    { lat: 48.2, lng: 1.5 },
    { lat: 48.2, lng: 2.9 },
    { lat: 49.2, lng: 2.9 },
    { lat: 49.2, lng: 1.5 },
    { lat: 48.2, lng: 1.5 }
  ]
};

// Region colors
export const regionColors = {
  "Occitanie": { fill: "rgba(140, 198, 63, 0.3)", stroke: "#8CC63F" },
  "Auvergne-Rhône-Alpes": { fill: "rgba(98, 146, 158, 0.3)", stroke: "#62929E" },
  "Île-de-France": { fill: "rgba(0, 127, 255, 0.3)", stroke: "#007FFF" }
};
